$(document).ready(function() {
	// Open and close content toggles
	$('.content-toggle__toggle').on('click', function() {

		// Trigger a window resize so that dimensions of child elements
		// hidden on page load can be recalculated, e.g. a Slick slider
		// within a `display: none;` content toggle div
		$(window).trigger('resize');

		$(this).toggleClass('content-toggle__toggle--active');

		var target = $(this).data( 'target' );
		$('.content-toggle[data-content=' + target + ']').toggleClass('content-toggle--active');

	});

	// Open and close content toggles
	$('.catalogue-block .content-toggle__header').on('click', function() {

		// Trigger a window resize so that dimensions of child elements
		// hidden on page load can be recalculated, e.g. a Slick slider
		// within a `display: none;` content toggle div
		$(window).trigger('resize');

		$(this).find('.content-toggle__toggle').toggleClass('content-toggle__toggle--active');

		var target = $(this).find('.content-toggle__toggle').data( 'target' );
		$('.content-toggle[data-content=' + target + ']').toggleClass('content-toggle--active');

	});

	$('.catalogue-block .content-toggle__toggle').unbind();
});

// Dynamically check the height of the content in a content toggle component
// and set a custom max-height. This allows for custom transition times to 
// avoid anything too fast or slow.
function checkContentToggleHeights() {
	$('.content-toggle__style').remove();
	$('.content-toggle').each(function() {
		$(this).append(
			'<div class="content-toggle__style"><style>.content-toggle[data-content="' + $(this).data('content') + '"].content-toggle--active .content-toggle__content { max-height: ' + $(this).find('.content-toggle__content').prop('scrollHeight') + 'px }.content-toggle[data-content="' + $(this).data('content') + '"].content-toggle--active .content-toggle__content {transition-duration: ' + ( ( ( $(this).find('.content-toggle__content').prop('scrollHeight') / 300 ) * 0.05 ) + 0.2 ) + 's}</style></div>'
		);
	});
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var optimisedContentHeights = debounce(checkContentToggleHeights, 250); // Debounce for performance
window.addEventListener('load', optimisedContentHeights);
window.addEventListener('resize', optimisedContentHeights);